module.exports = {
	"Standard Parcel": "Standard",
	"Express Parcel": "Express",
	"Front Door Freight": "Front Door"
};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Shipping/displayTransformations.json
// module id = 1011
// module chunks = 4 7 14